'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {Doughnut} from 'react-chartjs'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactSlidedown = require('react-slidedown');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _PlanScorecard = require('./PlanScorecard.css');

var _PlanScorecard2 = _interopRequireDefault(_PlanScorecard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecard = (_dec = (0, _reactCssModules2.default)(_PlanScorecard2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecard, _Component);

  function PlanScorecard(props) {
    (0, _classCallCheck3.default)(this, PlanScorecard);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecard.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecard)).call(this, props));

    _this.state = {
      showDefaultTargetDateScorecard: false,
      showSriOptionScorecards: false,
      defaultSelect: {
        label: 'Vanguard Target Retirement 2050 Fund',
        value: 'FSUSA072BK'
      }
    };
    return _this;
  }

  (0, _createClass3.default)(PlanScorecard, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.props.params.planId) {
        this.context.router.push(_config2.default.routes.plans);
        return _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      var planId = this.props.params.planId;

      var planData = _config2.default.plansSource[planId];

      if (!planData) {
        this.context.router.push(_config2.default.routes.plans);
        return _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      var title = planData.short_name;
      var description = 'See how ' + planData.plan_short_name + ' is rated on environmental and social sustainability issues.';
      var url = _config2.default.domain + _config2.default.routes.plans + '/' + planId;

      //
      var sriIcon = require('../../../static/images/sri.png');
      // const fffIcon = require( '../../../static/images/icons/fff-icon.svg' )
      // const dffIcon = require( '../../../static/images/icons/dff-icon.svg' )
      // const gefIcon = require( '../../../static/images/icons/gef-icon.svg' )
      // const gffIcon = require( '../../../static/images/icons/gff-icon.svg' )
      // const pffIcon = require( '../../../static/images/icons/pff-icon.svg' )
      // const wffIcon = require( '../../../static/images/icons/wff-icon.svg' )
      // const tffIcon = require( '../../../static/images/icons/tff-icon.svg' )
      //

      // calculate allocation %s
      var allocationStats = {};
      var allocationLabels = ['default', 'equity', 'bond', 'other', 'sri'];
      allocationLabels.map(function (e, i) {
        allocationStats[e] = {
          usd: _format2.default.money(planData.allocations[e], true, true),
          perc: Math.round(planData.allocations[e] / planData.plan_assets * 100.0),
          percOther: 100 - Math.round(planData.allocations[e] / planData.plan_assets * 100.0),
          percStr: _format2.default.perc(planData.allocations[e] / planData.plan_assets)
        };
        return null;
      });
      allocationStats.default.count = planData.default_plan_options.length;
      allocationStats.equity.count = planData.equity_plan_options.length;
      allocationStats.bond.count = planData.bond_plan_options.length;
      allocationStats.other.count = planData.other_plan_options.length;
      allocationStats.sri.count = planData.plan_option_sri_count;

      var planOptionMapFn = function planOptionMapFn(e, i) {
        var planOptionFull = _config2.default.planOptionsSource[e[0]];
        if (!planOptionFull) {
          return {
            investment_vehicle_id: '',
            label: e[1],
            assets: e[2],
            fund_type: e[3]
          };
        }
        planOptionFull.investment_vehicle_id = e[0];
        planOptionFull.label = e[1];
        planOptionFull.assets = e[2];
        planOptionFull.fund_type = e[3];
        return planOptionFull;
      };

      planData.default_plan_options.sort(function (a, b) {
        return a[2] < b[2] ? 1 : -1;
      });
      planData.equity_plan_options.sort(function (a, b) {
        return a[2] < b[2] ? 1 : -1;
      });
      planData.bond_plan_options.sort(function (a, b) {
        return a[2] < b[2] ? 1 : -1;
      });
      planData.other_plan_options.sort(function (a, b) {
        return a[2] < b[2] ? 1 : -1;
      });
      var planOptions = {
        ratedAs: planData.rated_as_option.map(planOptionMapFn),
        default: planData.default_plan_options.map(planOptionMapFn),
        equity: planData.equity_plan_options.map(planOptionMapFn),
        bond: planData.bond_plan_options.map(planOptionMapFn),
        other: planData.other_plan_options.map(planOptionMapFn),
        all: planData.default_plan_options.concat(planData.equity_plan_options, planData.bond_plan_options, planData.other_plan_options).map(planOptionMapFn).sort(function (a, b) {
          return b.assets - a.assets;
        })
      };

      // This will be the 2050 fund of the target date series
      // that is the default plan lineup
      var currDefaultFund = planOptions.ratedAs.filter(function (e, i) {
        return true;
      }).pop();

      var currSRIFunds = planOptions.equity.filter(function (e, i) {
        if (e.sustainable_investment === 1) {
          return true;
        }
        return false;
      });

      //
      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        (0, _keys2.default)(_config2.default.plansBondsSource).includes(this.props.params.planId) ? _react2.default.createElement(
          'div',
          { styleName: 'bond-clickthrough' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.fossilFuelBondsIn401ks,
                title: 'Fossil Fuel Bonds in 401(k)s'
              },
              'New! See more about this plan in our new analysis of Fossil Fuel Bonds in 401(k)s',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        ) : null,
        _react2.default.createElement(_components.PlanScorecardHeader, { planId: planId, planData: planData }),
        _react2.default.createElement(
          'div',
          { styleName: 'gray-bckgrnd', id: 'scores' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(_components.PlanScorecardNameHeader, { planData: planData }),
            _react2.default.createElement(_components.PlanScorecardDefaultScorecard, { fund: currDefaultFund }),
            _react2.default.createElement(_components.PlanScorecardTakeActionShare, {
              description: description,
              url: url
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_components.PlanScorecardDefaultAllocation, {
              allocationStats: allocationStats,
              planData: planData
            }),
            _react2.default.createElement(
              'button',
              {
                styleName: 'section-slidedown-button',
                onClick: function onClick(e) {
                  _this2.setState({
                    showDefaultTargetDateScorecard: !_this2.state.showDefaultTargetDateScorecard
                  });
                }
              },
              _react2.default.createElement(
                'h3',
                { styleName: 'section-slidedown-label' },
                'Target date scorecard'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'section-slidedown-icon' },
                _react2.default.createElement(_components.LinkIcon, {
                  faclass: this.state.showDefaultTargetDateScorecard ? 'fa-angle-up' : 'fa-angle-down'
                })
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              _reactSlidedown.SlideDown,
              null,
              this.state.showDefaultTargetDateScorecard ? _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, sm: 12, md: 9 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'fund-card' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'title-select-wrap' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'datatitle' },
                        currDefaultFund.fund_legal_name
                      )
                    ),
                    _react2.default.createElement(_components.PlanScorecardFundIssueAccordion, {
                      fund: currDefaultFund
                    }),
                    _react2.default.createElement(_components.PlanScorecardFundDetails, {
                      fund: currDefaultFund
                    })
                  )
                )
              ) : null
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_components.PlanScorecardIssueAllocations, {
              planData: planData
            }),
            _react2.default.createElement(_components.PlanScorecardSustainableAccess, {
              planData: planData,
              allocationStats: allocationStats
            }),
            planData.plan_option_sri_count && planData.plan_option_sri_count > 0 ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                {
                  styleName: 'section-slidedown-button',
                  onClick: function onClick(e) {
                    _this2.setState({
                      showSriOptionScorecards: !_this2.state.showSriOptionScorecards
                    });
                  }
                },
                _react2.default.createElement(
                  'h3',
                  { styleName: 'section-slidedown-label' },
                  'Sustainable plan options'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'section-slidedown-icon' },
                  _react2.default.createElement(_components.LinkIcon, {
                    faclass: this.state.showDefaultTargetDateScorecard ? 'fa-angle-up' : 'fa-angle-down'
                  })
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                _reactSlidedown.SlideDown,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Row,
                  null,
                  this.state.showSriOptionScorecards ? currSRIFunds.map(function (currSRIFund, i) {
                    var colWid = currSRIFunds.length > 1 ? 6 : 9;
                    return _react2.default.createElement(
                      _reactFlexboxGrid.Col,
                      { xs: 12, sm: 12, md: colWid },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'fund-card' },
                        _react2.default.createElement(
                          'div',
                          { styleName: 'title-select-wrap' },
                          _react2.default.createElement(
                            'div',
                            { styleName: 'datatitle-sus' },
                            currSRIFund.fund_legal_name
                          ),
                          _react2.default.createElement('img', {
                            styleName: 'sri',
                            src: sriIcon,
                            alt: 'Sustainability mandate',
                            'data-multiline': true,
                            'data-effect': 'solid',
                            'data-tip': _format2.default.tooltipHtml('Reports a ' + 'Sustainability Mandate to Morningstar. ' + 'Sustainable funds consider issues like the ' + 'environment and human rights.'),
                            'data-html': true,
                            'data-place': 'bottom',
                            'data-for': 'fundname-sri-tooltip'
                          }),
                          _react2.default.createElement(_reactTooltip2.default, { id: 'fundname-sri-tooltip' })
                        ),
                        _react2.default.createElement(_components.PlanScorecardFundIssueAccordion, {
                          fund: currSRIFund
                        }),
                        _react2.default.createElement(_components.PlanScorecardFundDetails, {
                          fund: currSRIFund
                        })
                      )
                    );
                  }) : null
                )
              )
            ) : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('br', null),
              _react2.default.createElement('br', null)
            )
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement(_components.PlanScorecardToActionCenter, null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement(_components.PlanScorecardSelfDirectedOption, {
            planData: planData
          }),
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_components.PlanScorecardInvestmentOptions, {
              planId: planId,
              allocationStats: allocationStats,
              planOptions: planOptions
            }),
            _react2.default.createElement(_components.PlanScorecardSourceData, {
              planId: planId,
              planData: planData,
              planOptions: planOptions
            }),
            _react2.default.createElement(_components.PlanScorecardCompanyLetter, {
              planPath: planData.path,
              url: this.props.location
            }),
            _react2.default.createElement(_components.PlanScorecardShareholderResolution, {
              planId: planId,
              planData: planData,
              url: this.props.location
            })
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null)
        )
      );
    }
  }]);
  return PlanScorecard;
}(_react.Component), _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PlanScorecard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PlanScorecard/PlanScorecard.js
// module id = 1494
// module chunks = 0